import lazyLoad from "@loadable/component";
import createPlugin from "./createPlugin";

import SubCategoryRenderer from "./Renderer/SubCategoryRenderer";
const SubCategoryForm = lazyLoad(() => import("./Form"));

const subCategoryPlugin = (settings) =>
    createPlugin({
        Renderer: SubCategoryRenderer,
        Controls: SubCategoryForm,
        ...settings,
    });

const subCategory = subCategoryPlugin();
export default subCategory;

export { subCategoryPlugin, SubCategoryRenderer };
